import React, {
  useState,
  useImperativeHandle,
  forwardRef,
} from 'react';

import './FeedBackLesson.css';
import imp1 from '../../imagesHome/imp1.png';
import imp2 from '../../imagesHome/imp2.png';
import imp3 from '../../imagesHome/imp3.png';
import imp4 from '../../imagesHome/imp4.png';
import imp5 from '../../imagesHome/imp5.png';

const FeedBackLesson = forwardRef(({ lessonId, chapterId, apiUrl, onFeedbackChange }, ref) => {
  const [rating, setRating] = useState(null);
  const [difficulty, setDifficulty] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const notifyParent = (nextRating, nextDifficulty, nextMessage) => {
    onFeedbackChange?.(
      nextRating !== null ||
      nextDifficulty !== '' ||
      nextMessage.trim() !== ''
    );
  };

  const handleRatingChange = (value) => {
    setRating(value);
    notifyParent(value, difficulty, message);
  };

  const handleDifficultyChange = (value) => {
    setDifficulty(value);
    notifyParent(rating, value, message);
  };

  const handleMessageChange = (value) => {
    setMessage(value);
    notifyParent(rating, difficulty, value);
  };

  const handleSubmit = async () => {
    if (!rating && !difficulty && !message.trim()) return true;

    try {
      const response = await fetch(`${apiUrl}/feedback/lesson`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          lessonId,
          chapterId,
          rating,
          difficulty,
          message,
        }),
      });

      if (!response.ok) {
        throw new Error('Feedbackul nu a putut fi salvat');
      }

      setSubmitted(true);
      return true;
    } catch (err) {
      console.error('Eroare la trimiterea feedbackului:', err);
      return false;
    }
  };

useImperativeHandle(ref, () => ({
  submitFeedback: handleSubmit,
  isSubmitted: () => submitted,
  hasFeedback: () =>
    rating !== null ||
    difficulty !== '' ||
    message.trim() !== '',
}));

  if (submitted) {
    return (
      <div className="feedback-lesson-card">
        <h3>Multumim pentru feedback! 💚</h3>
        <p>Parerea ta ne ajuta sa imbunatatim lectiile ContaLearn.</p>
      </div>
    );
  }

  return (
    <div className="feedback-lesson-card">
      <h3>Cum ti s-a parut lectia?</h3>

      <div className="feedback-rating-row">
        {[
          { value: 1, image: imp1 },
          { value: 2, image: imp2 },
          { value: 3, image: imp3 },
          { value: 4, image: imp4 },
          { value: 5, image: imp5 },
        ].map((item) => (
          <button
            key={item.value}
            type="button"
            className={rating === item.value ? 'feedback-rating active' : 'feedback-rating'}
            onClick={() => handleRatingChange(item.value)}
          >
            <img
              src={item.image}
              alt={`Feedback ${item.value}`}
              className="feedback-rating-image"
            />
          </button>
        ))}
      </div>

      <div className="feedback-difficulty">
        <button
          type="button"
          className={difficulty === 'usoara' ? 'active' : ''}
          onClick={() => handleDifficultyChange('usoara')}
        >
          usoara
        </button>

        <button
          type="button"
          className={difficulty === 'potrivita' ? 'active' : ''}
          onClick={() => handleDifficultyChange('potrivita')}
        >
          potrivita
        </button>

        <button
          type="button"
          className={difficulty === 'dificila' ? 'active' : ''}
          onClick={() => handleDifficultyChange('dificila')}
        >
          dificila
        </button>
      </div>

      <textarea
        value={message}
        onChange={(e) => handleMessageChange(e.target.value)}
        placeholder="Ce ai imbunatati la aceasta lectie?"
      />
    </div>
  );
});

export default FeedBackLesson;